import gql from 'graphql-tag';

export const NAME = 'compositions_CaseBillingPanel_caseBillingInfoQuery';

const query = gql`
  query ${NAME} ($caseNumber: String!) {
    case (caseNumber: $caseNumber) {
      id
      billingInfo {
        amount
        comment
        poNumber
        woNumber
        ticketNumber
        invoiceNumber
        referenceNumber
        contractNumber
        releaseNumber
      }
      customer(useCachedDataForCase: true) {
        ... on Customer {
          id
          billingPreferences {
            purchaseOrderRule
            releaseNumberRule: releaseNumber
            contractNumberRule: contractNumber
          }
        }
        ... on StoreCustomer {
          id
          billingPreferences {
            purchaseOrderRule
            releaseNumberRule: releaseNumber
            contractNumberRule: contractNumber
          }
        }
      }
    }
  }
`;

export default query;



// WEBPACK FOOTER //
// ./src/compositions/CaseBillingPanel/caseBillingInfoQuery.js